document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('change', (event) => {
    if (event.target.matches('.swatch-input__input')) {
      updateProductCard(event.target);
    }
  });
});

/**
 * Updates the product card display based on the selected swatch input.
 * @param {HTMLInputElement} input The specific swatch input element that was changed.
 */
function updateProductCard(input) {
  const productCard = input.closest('.product-card-wrapper[data-product-id]');

  if (!productCard) {
    return;
  }

  const variantTitle = input.dataset.variantTitle ?? null; 
  const variantPrice = input.dataset.variantPrice ?? null;
  const variantCompareAtPrice = input.dataset.variantCompareAtPrice || null; 
  const variantImage = input.dataset.variantImage || null;

  const titleElement = productCard.querySelector('.card__variant-heading');
  const priceContainer = productCard.querySelector('.price');
  const mainImageContainer = productCard.querySelector('.card__media');
  const mainImage = mainImageContainer ? mainImageContainer.querySelector('img') : null;

  // Update title
  if (titleElement && variantTitle !== null) {
    titleElement.textContent = variantTitle;
  }

  // Update price
  if (priceContainer && variantPrice !== null) {
    const regularPriceContainer = priceContainer.querySelector('.price__regular');
    const salePriceContainer = priceContainer.querySelector('.price__sale');

    if (regularPriceContainer) {
        const regularPriceElement = regularPriceContainer.querySelector('.price-item--regular');
        if (regularPriceElement) {
            regularPriceElement.textContent = variantPrice;
        }
        regularPriceContainer.style.display = variantCompareAtPrice ? 'none' : '';
    }

    if (salePriceContainer) {
        const salePriceFinalElement = salePriceContainer.querySelector('.price-item--sale');
        const salePriceCompareElement = salePriceContainer.querySelector('.price-item--regular');

        if (variantCompareAtPrice) {
            if (salePriceFinalElement) salePriceFinalElement.textContent = variantPrice;
            if (salePriceCompareElement) salePriceCompareElement.textContent = variantCompareAtPrice;
            salePriceContainer.style.display = ''; 
        } else {
            salePriceContainer.style.display = 'none';
        }
    }
  }

  // Update image
  if (mainImage && variantImage) {
    const imageSizes = [165, 360, 533, 720, 940, 1066]; 
    const srcsetValues = imageSizes.map(size => {
        let baseUrl = variantImage.split('?')[0];
        const query = variantImage.split('?')[1] ? `?${variantImage.split('?')[1]}` : '';
        let sizedUrl = baseUrl.replace(/(_\d+x)?(\.\w+$)/, `_${size}x$2`);
        if (!sizedUrl.includes(`_${size}x`)) { 
            sizedUrl = baseUrl.replace(/(\.\w+$)/, `_${size}x$1`);
        }
        return `${sizedUrl}${query} ${size}w`;
    }).join(', ');

    mainImage.srcset = srcsetValues;

    let srcUrl = variantImage.split('?')[0];
    const srcQuery = variantImage.split('?')[1] ? `?${variantImage.split('?')[1]}` : '';
    let srcSizedUrl = srcUrl.replace(/(_\d+x)?(\.\w+$)/, `_533x$2`);
    if (!srcSizedUrl.includes(`_533x`)) {
        srcSizedUrl = srcUrl.replace(/(\.\w+$)/, `_533x$1`);
    }
    mainImage.src = `${srcSizedUrl}${srcQuery}`;
  }
}